module.exports = __webpack_public_path__ + "34e853c9288061944e3f43b8306b9c32.MP3";